import React from 'react';
import {Box, Typography, Grid, Card, CardContent, Button, CardMedia} from '@mui/material';
import { Link as RouterLink} from 'react-router-dom';
import he from 'he';
import { truncateString } from '../../../common/utils/utils';

const CommonStories = (props: any) => {
    const { data } = props;

    const truncateContent = (content: string) => {
        // Remove HTML tags and decode entities
        const decodedContent = he.decode(content.replace(/<[^>]*>/g, ''));
        return truncateString(decodedContent, 150); // Adjust 150 to your desired character length
    };

    if (data !== null) {
        return data.map((commonData: any, index: any) => { 
            return (
                <React.Fragment key={index}>
                    <Grid item xs={12} md={6} lg={4}>
                        <Card className='blog-box' sx={{ 
                            borderTopLeftRadius: 0, 
                            borderTopRightRadius: 0, 
                            boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.1)',
                            height: '100%', // Make all cards same height
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <Box display='flex' alignItems='start' justifyContent='end'>
                                <CardMedia
                                    component="img"
                                    height="288"
                                    image={commonData.field_blog_bannerimage}
                                    alt=""
                                />
                            </Box>
                            <CardContent sx={{ 
                                p: '24px',
                                flex: 1, // Allow content to fill available space
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}>
                                <Box>
                                    <Typography 
                                        variant="h5" 
                                        fontSize='28px' 
                                        mb={2}
                                        sx={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: '2',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            lineHeight: '1.2',
                                            height: '67px' // Approximately 2 lines of text
                                        }}
                                    >
                                        {he.decode(commonData.title)}
                                    </Typography>
                                    
                                    {commonData.body && (
                                        <Typography 
                                            sx={{
                                                mb: 3,
                                                display: '-webkit-box',
                                                WebkitLineClamp: '2',
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                lineHeight: '1.5',
                                                height: '48px', // Approximately 2 lines of text
                                                color: '#666'
                                            }}
                                        >
                                            {truncateContent(commonData.body)}
                                        </Typography>
                                    )}
                                </Box>
                                
                                <RouterLink 
                                    to={`/StoryDetails${commonData.field_blog_address_url}`} 
                                    state={{searchResultData:data, currentIndex:index}}
                                >
                                    <Button 
                                        sx={{ 
                                            padding: '0 25px', 
                                            fontSize: '18px', 
                                            fontWeight: '500 !important',
                                            width: '170px', 
                                            height: '46px'
                                        }} 
                                        className='btn-blue' 
                                    >
                                        READ MORE
                                    </Button>
                                </RouterLink>
                            </CardContent>
                        </Card>
                    </Grid>
                </React.Fragment>
            );
        })
    } else {
        return (
            <React.Fragment>
                <></>
            </React.Fragment>
        )
    }
};

export default CommonStories;
